// Webform disable submit until requried fields filled
Drupal.behaviors.sw_webform_required = {
  attach: function( context, settings ) {
    $('form').once('sw_webform_required').each(function() {
      let fw = new SwFormRequired($(this));
    });
  }
}

let SwFormRequired = function( $form ) {
  let _this = this;
  this.$form = $form;

  $form.on('change keydown', 'input,select', function() {
    _this.checkRequired();
  });
  this.$form.on('click', '.form-actions', function( e ) {
    //console.log(e);
  });

  this.checkRequired();
  setTimeout(function() {
    _this.checkRequired();
  }, 500);
}
SwFormRequired.prototype.checkRequired = function() {
  //console.log(this.isRequiredFilled());
  let $submit = this.$form.find('input[type="submit"]').not('[formnovalidate="formnovalidate"]');
  // We add dialog buttons, if form is inside dialog
  $submit = $submit.add(this.$form.closest('.ui-dialog').find('.ui-dialog-buttonpane button'));
  if ( this.isRequiredFilled()) {
    $submit.prop('disabled', false);
  } else {
    //$submit.prop('disabled', true);
  }
};
SwFormRequired.prototype.isRequiredFilled = function() {
  let is_valid = true;
  this.$form.find('input,select').each(function() {
    let $i = $(this);
    if ($i.attr('required') && $i.val().length === 0 ) {
      is_valid = false;
    }
  });
  return is_valid;
};
